var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"admin-page-content"},[_c('div',{staticClass:"col-md-12 error-detail-main forms-container"},[_c('div',{staticClass:"error-template"},[_c('h1',[_vm._v("Oops!")]),_c('h2',[_vm._v("403")]),_c('div',{staticClass:"error-details"},[_vm._v("Sorry!, You don't have permission to access this page.")])])])])
}]

export { render, staticRenderFns }